import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
    const socialBase = 'https://www.';

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <footer className="bg-gray-800 text-gray-300 mt-12">
            <div className="bg-gray-700 hover:bg-gray-600 transition-colors">
                <button onClick={scrollToTop} className="w-full py-4 text-white font-semibold">
                    Back to top
                </button>
            </div>

            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-8">
                <div className="space-y-4">
                    <h4 className="text-white font-bold text-lg">Get to Know Us</h4>
                    <ul className="space-y-2">
                        <li><Link to="/about" className="hover:text-yellow-400 transition-colors">About LumioTec</Link></li>
                        <li><Link to="/contact" className="hover:text-yellow-400 transition-colors">Contact Us</Link></li>
                        <li><Link to="/careers" className="hover:text-yellow-400 transition-colors">Careers</Link></li>
                        <li><Link to="/blog" className="hover:text-yellow-400 transition-colors">Blog</Link></li>
                    </ul>
                </div>
                
                <div className="space-y-4">
                    <h4 className="text-white font-bold text-lg">Shop with Us</h4>
                    <ul className="space-y-2">
                        <li><Link to="/today-deals" className="hover:text-yellow-400 transition-colors">Today's Deals</Link></li>
                        <li><Link to="/account" className="hover:text-yellow-400 transition-colors">Your Account</Link></li>
                        <li><Link to="/orders" className="hover:text-yellow-400 transition-colors">Your Orders</Link></li>
                        <li><Link to="/wishlist" className="hover:text-yellow-400 transition-colors">Your Wishlist</Link></li>
                    </ul>
                </div>
                
                <div className="space-y-4">
                    <h4 className="text-white font-bold text-lg">Policies & Help</h4>
                    <ul className="space-y-2">
                        <li><Link to="/policies/shipping" className="hover:text-yellow-400 transition-colors">Shipping Rates</Link></li>
                        <li><Link to="/policies/returns" className="hover:text-yellow-400 transition-colors">Returns & Replacements</Link></li>
                        <li><Link to="/policies/privacy" className="hover:text-yellow-400 transition-colors">Privacy Policy</Link></li>
                        <li><Link to="/help" className="hover:text-yellow-400 transition-colors">Help Center</Link></li>
                    </ul>
                </div>
                
                <div className="space-y-4">
                    <h4 className="text-white font-bold text-lg">Connect with Us</h4>
                    <div className="flex space-x-4">
                        <a href={`${socialBase}facebook.com/lumiotechke`} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-2xl hover:text-yellow-400 transition-colors"><FaFacebook /></a>
                        <a href={`${socialBase}twitter.com/lumiotechke`} target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-2xl hover:text-yellow-400 transition-colors"><FaTwitter /></a>
                        <a href={`${socialBase}instagram.com/lumiotechke`} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-2xl hover:text-yellow-400 transition-colors"><FaInstagram /></a>
                        <a href={`${socialBase}linkedin.com/company/lumiotechke`} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-2xl hover:text-yellow-400 transition-colors"><FaLinkedin /></a>
                    </div>
                </div>
            </div>

            <div className="bg-gray-900 py-6">
                <div className="max-w-7xl mx-auto text-center text-gray-400">
                    <img src="/lumio_logo.png" alt="LumioTec Logo" className="h-10 mx-auto mb-4 filter brightness-0 invert"/>
                    <p>&copy; {new Date().getFullYear()} LumioTec ELECTRICALS. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;